import { getDateInTimeZone } from 'utils/events';
import { AddToCalendarButtonContainerProps } from './AddToCalendarButtonContainer';

type EventData = AddToCalendarButtonContainerProps['eventData'];

export const generateICSFile = (eventData: EventData) => {
  const {
    name,
    location,
    timeInterval: { startsAt, endsAt },
    timezone,
  } = eventData;

  const formatDate = (date: string) => {
    return getDateInTimeZone(date, timezone)
      .toUTC()
      .toFormat("yyyyLLdd'T'HHmmss'Z'");
  };

  const startDate = formatDate(startsAt);
  const endDate = formatDate(endsAt);

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Your Company//Your Product//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    }`,
    `SUMMARY:${name}`,
    `DTSTAMP:${formatDate(new Date().toISOString())}`,
    `DTSTART:${startDate}`,
    `DTEND:${endDate}`,
    `LOCATION:${location}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute('download', `${name.replace(/\s+/g, '-')}.ics`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const redirectToGoogleCalendar = (eventData: EventData) => {
  const {
    name,
    location,
    timeInterval: { startsAt, endsAt },
    timezone,
  } = eventData;

  const formattedStartDate = getDateInTimeZone(startsAt, timezone).toFormat(
    'yyyyLLdd',
  );
  const formattedStartTime = getDateInTimeZone(startsAt, timezone).toFormat(
    'HHmm',
  );
  const formattedEndDate = getDateInTimeZone(endsAt, timezone).toFormat(
    'yyyyLLdd',
  );
  const formattedEndTime = getDateInTimeZone(endsAt, timezone).toFormat('HHmm');

  const start = `${formattedStartDate}T${formattedStartTime}:00`;
  const end = `${formattedEndDate}T${formattedEndTime}:00`;

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: name,
    dates: `${start}/${end}`,
    ctz: timezone,
    location: location,
  });

  window.open(
    `https://calendar.google.com/calendar/render?${params.toString()}`,
    '_blank',
  );
};

export const redirectToOutlookCalendar = (eventData: EventData) => {
  const {
    name,
    location,
    timeInterval: { startsAt, endsAt },
    timezone,
  } = eventData;

  const formattedStartDate = getDateInTimeZone(startsAt, timezone).toFormat(
    'yyyy-LL-dd',
  );
  const formattedStartTime = getDateInTimeZone(startsAt, timezone).toFormat(
    'HH:mm',
  );
  const formattedEndDate = getDateInTimeZone(endsAt, timezone).toFormat(
    'yyyy-LL-dd',
  );
  const formattedEndTime = getDateInTimeZone(endsAt, timezone).toFormat(
    'HH:mm',
  );

  const params = new URLSearchParams({
    rru: 'addevent',
    subject: name,
    startdt: `${formattedStartDate}T${formattedStartTime}`,
    enddt: `${formattedEndDate}T${formattedEndTime}`,
    location: location,
    timezone: timezone,
  });

  window.open(
    `https://outlook.live.com/calendar/0/action/compose?allday=false&${params.toString()}`,
    '_blank',
  );
};
